export enum PremiumPaymentType {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX',
    UNKNOWN = 'UNKNOWN',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}